import React, { useEffect, useRef } from 'react';
import { Container } from '@hvcgroep/design-system';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ReactComponent as LogoTruncated } from '../../assets/images/logo-truncated.svg';
import { LOG_OUT_URL } from '../../config/constants';

import './style.scss';
import { api } from '../../store/api';
import { contractReset } from '../../store/actions/SelectedContract';

// @TODO: Awaiting design

const LoggingOutPage: React.FC = () => {
  const dispatch = useDispatch();
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (!formRef.current) {
      return;
    }

    /**
    * Reset the state before actually logging out, so that the last thing visible on the screen
    * is a non-authenticated view. This may be desirable in situations in which the browser hits the
    * "back" button after logging out. Sometimes, the browser shows the last view when returning to
    * a page in history.
    */
    dispatch(api.util.resetApiState());
    dispatch(contractReset());

    // Submit the form programmatically to trigger POST
    formRef.current?.submit();
  }, [dispatch]);

  return (
    <Container fluid>
      <section className="d-flex mo-logIn">
        <div>
          <LogoTruncated />
        </div>
        <div>
          <h1>Uitloggen...</h1>
          <form
            ref={formRef}
            action={LOG_OUT_URL}
            method="post"
            style={{ display: 'none' }}
          />
        </div>
      </section>
    </Container>
  );
};

export default LoggingOutPage;
